<div class="flex flex-row settings-menu-item" [ngClass]="{'opened': selected}">
  <div [class]="getCSSClass(indicator)" [ngClass]="{'opened': selected}">
    &nbsp;
  </div>
  <div class="settings-menu-item-text" [ngClass]="{'opened': selected}">
    {{title}}
  </div>
</div>
